import { Injectable } from '@angular/core';
import { GeneralHttpService } from 'src/app/shared/general-http.service';
import { AmparoDocumento } from './amparo-documento.model';

@Injectable({
  providedIn: 'root'
})
export class AmparoDocumentoService {
  listDocuments:AmparoDocumento[];
  private routeApi = "AdmAmparoDocumentoes"
  constructor(private generalHttp:GeneralHttpService) { }

  getDocumentsByidAmparo(id:number){
    return this.generalHttp.getHttpById(id,this.routeApi + '/ByAmparo').then(r => this.listDocuments = r as AmparoDocumento[]);
  }

  postDocument(form:AmparoDocumento){
    return this.generalHttp.postHttp(form,this.routeApi)
  }

  updateDocument(form:AmparoDocumento,id:number){
    return this.generalHttp.putHttp(form,id,this.routeApi);
  }

  deleteDocument(id:number){
    return this.generalHttp.deleteHttp(id,this.routeApi);
  }

}
